"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletConnectConnector = exports.CeloExtensionWalletConnector = exports.MetaMaskConnector = exports.InjectedConnector = exports.UnsupportedChainIdError = exports.LedgerConnector = exports.PrivateKeyConnector = exports.UnauthenticatedConnector = void 0;
var contractkit_1 = require("@celo/contractkit");
var wallet_local_1 = require("@celo/wallet-local");
// Uncomment with WCV2 support
// import {
//   WalletConnectWallet,
//   WalletConnectWalletOptions,
// } from '@celo/wallet-walletconnect';
var wallet_walletconnect_v1_1 = require("@celo/wallet-walletconnect-v1");
var bignumber_js_1 = require("bignumber.js");
var constants_1 = require("../constants");
var ethereum_1 = require("../utils/ethereum");
var helpers_1 = require("../utils/helpers");
var localStorage_1 = __importDefault(require("../utils/localStorage"));
var metamask_1 = require("../utils/metamask");
/**
 * Connectors are our link between a DApp and the users wallet. Each
 * wallet has different semantics and these classes attempt to unify
 * them and present a workable API.
 */
var UnauthenticatedConnector = /** @class */ (function () {
    function UnauthenticatedConnector(n) {
        this.initialised = true;
        this.type = constants_1.WalletTypes.Unauthenticated;
        this.account = null;
        this.feeCurrency = contractkit_1.CeloContract.GoldToken;
        this.kit = (0, contractkit_1.newKit)(n.rpcUrl);
    }
    UnauthenticatedConnector.prototype.initialise = function () {
        this.initialised = true;
        return this;
    };
    UnauthenticatedConnector.prototype.updateFeeCurrency = function (feeContract) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.feeCurrency = feeContract;
                        return [4 /*yield*/, this.kit.setFeeCurrency(feeContract)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UnauthenticatedConnector.prototype.close = function () {
        (0, helpers_1.clearPreviousConfig)();
        return;
    };
    return UnauthenticatedConnector;
}());
exports.UnauthenticatedConnector = UnauthenticatedConnector;
var PrivateKeyConnector = /** @class */ (function () {
    function PrivateKeyConnector(n, privateKey, feeCurrency) {
        var _a;
        this.feeCurrency = feeCurrency;
        this.initialised = true;
        this.type = constants_1.WalletTypes.PrivateKey;
        this.account = null;
        localStorage_1.default.setItem(constants_1.localStorageKeys.lastUsedWalletType, constants_1.WalletTypes.PrivateKey);
        localStorage_1.default.setItem(constants_1.localStorageKeys.lastUsedWalletArguments, JSON.stringify([privateKey]));
        localStorage_1.default.setItem(constants_1.localStorageKeys.lastUsedNetwork, n.name);
        var wallet = new wallet_local_1.LocalWallet();
        wallet.addAccount(privateKey);
        this.kit = (0, contractkit_1.newKit)(n.rpcUrl, wallet);
        this.kit.defaultAccount = wallet.getAccounts()[0];
        this.account = (_a = this.kit.defaultAccount) !== null && _a !== void 0 ? _a : null;
    }
    PrivateKeyConnector.prototype.initialise = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateFeeCurrency(this.feeCurrency)];
                    case 1:
                        _a.sent();
                        this.initialised = true;
                        return [2 /*return*/, this];
                }
            });
        });
    };
    PrivateKeyConnector.prototype.updateFeeCurrency = function (feeContract) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.feeCurrency = feeContract;
                        return [4 /*yield*/, this.kit.setFeeCurrency(feeContract)];
                    case 1:
                        res = _a.sent();
                        console.log(res, 'console');
                        return [2 /*return*/];
                }
            });
        });
    };
    PrivateKeyConnector.prototype.close = function () {
        (0, helpers_1.clearPreviousConfig)();
        return;
    };
    return PrivateKeyConnector;
}());
exports.PrivateKeyConnector = PrivateKeyConnector;
var LedgerConnector = /** @class */ (function () {
    function LedgerConnector(network, index, feeCurrency) {
        this.network = network;
        this.index = index;
        this.feeCurrency = feeCurrency;
        this.initialised = false;
        this.type = constants_1.WalletTypes.Ledger;
        this.account = null;
        localStorage_1.default.setItem(constants_1.localStorageKeys.lastUsedWalletType, constants_1.WalletTypes.Ledger);
        localStorage_1.default.setItem(constants_1.localStorageKeys.lastUsedWalletArguments, JSON.stringify([index]));
        localStorage_1.default.setItem(constants_1.localStorageKeys.lastUsedNetwork, network.name);
        this.kit = (0, contractkit_1.newKit)(network.rpcUrl);
        console.log(this.kit, 'kit');
    }
    LedgerConnector.prototype.initialise = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var TransportUSB, newLedgerWalletWithSetup, transport, wallet;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('@ledgerhq/hw-transport-webusb')); })];
                    case 1:
                        TransportUSB = (_b.sent()).default;
                        return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('@celo/wallet-ledger')); })];
                    case 2:
                        newLedgerWalletWithSetup = (_b.sent()).newLedgerWalletWithSetup;
                        return [4 /*yield*/, TransportUSB.create()];
                    case 3:
                        transport = _b.sent();
                        return [4 /*yield*/, newLedgerWalletWithSetup(transport, [this.index])];
                    case 4:
                        wallet = _b.sent();
                        this.kit = (0, contractkit_1.newKit)(this.network.rpcUrl, wallet);
                        this.kit.defaultAccount = wallet.getAccounts()[0];
                        this.initialised = true;
                        this.account = (_a = this.kit.defaultAccount) !== null && _a !== void 0 ? _a : null;
                        return [4 /*yield*/, this.updateFeeCurrency(this.feeCurrency)];
                    case 5:
                        _b.sent();
                        return [2 /*return*/, this];
                }
            });
        });
    };
    LedgerConnector.prototype.updateFeeCurrency = function (feeContract) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.feeCurrency = feeContract;
                        return [4 /*yield*/, this.kit.setFeeCurrency(feeContract)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LedgerConnector.prototype.close = function () {
        (0, helpers_1.clearPreviousConfig)();
        return;
    };
    return LedgerConnector;
}());
exports.LedgerConnector = LedgerConnector;
var UnsupportedChainIdError = /** @class */ (function (_super) {
    __extends(UnsupportedChainIdError, _super);
    function UnsupportedChainIdError(chainID) {
        var _this = _super.call(this, "Unsupported chain ID: ".concat(chainID)) || this;
        _this.chainID = chainID;
        _this.name = UnsupportedChainIdError.NAME;
        return _this;
    }
    UnsupportedChainIdError.NAME = 'UnsupportedChainIdError';
    return UnsupportedChainIdError;
}(Error));
exports.UnsupportedChainIdError = UnsupportedChainIdError;
var InjectedConnector = /** @class */ (function () {
    function InjectedConnector(network, feeCurrency, defaultType) {
        var _this = this;
        if (defaultType === void 0) { defaultType = constants_1.WalletTypes.Injected; }
        this.feeCurrency = feeCurrency;
        this.initialised = false;
        this.type = constants_1.WalletTypes.CeloExtensionWallet;
        this.account = null;
        this.onChainChanged = function (chainIdHex) {
            var chainId = parseInt(chainIdHex, 16);
            if (_this.onNetworkChangeCallback && _this.network.chainId !== chainId) {
                _this.onNetworkChangeCallback(chainId);
            }
        };
        this.onAccountsChanged = function (accounts) {
            var _a;
            if (_this.onAddressChangeCallback) {
                _this.kit.defaultAccount = accounts[0];
                _this.onAddressChangeCallback((_a = accounts[0]) !== null && _a !== void 0 ? _a : null);
            }
        };
        this.type = defaultType;
        localStorage_1.default.setItem(constants_1.localStorageKeys.lastUsedWalletType, defaultType);
        localStorage_1.default.setItem(constants_1.localStorageKeys.lastUsedWalletArguments, JSON.stringify([feeCurrency]));
        localStorage_1.default.setItem(constants_1.localStorageKeys.lastUsedNetwork, network.name);
        this.kit = (0, contractkit_1.newKit)(network.rpcUrl);
        this.network = network;
    }
    InjectedConnector.prototype.initialise = function () {
        return __awaiter(this, void 0, void 0, function () {
            var injected, web3, ethereum, isMetaMask, _a, defaultAccount;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, (0, ethereum_1.getInjectedEthereum)()];
                    case 1:
                        injected = _b.sent();
                        if (!injected) {
                            throw new Error('Ethereum wallet not installed');
                        }
                        web3 = injected.web3, ethereum = injected.ethereum, isMetaMask = injected.isMetaMask;
                        this.type = isMetaMask ? constants_1.WalletTypes.MetaMask : constants_1.WalletTypes.Injected;
                        return [4 /*yield*/, ethereum.request({ method: 'eth_requestAccounts' })];
                    case 2:
                        void (_b.sent());
                        ethereum.removeListener('chainChanged', this.onChainChanged);
                        ethereum.removeListener('accountsChanged', this.onAccountsChanged);
                        return [4 /*yield*/, (0, metamask_1.switchToCeloNetwork)(this.kit, this.network, ethereum)];
                    case 3:
                        _b.sent();
                        ethereum.on('chainChanged', this.onChainChanged);
                        ethereum.on('accountsChanged', this.onAccountsChanged);
                        this.kit = (0, contractkit_1.newKitFromWeb3)(web3);
                        return [4 /*yield*/, this.kit.web3.eth.getAccounts()];
                    case 4:
                        _a = __read.apply(void 0, [_b.sent(), 1]), defaultAccount = _a[0];
                        this.kit.defaultAccount = defaultAccount;
                        this.account = defaultAccount !== null && defaultAccount !== void 0 ? defaultAccount : null;
                        return [4 /*yield*/, this.updateFeeCurrency(this.feeCurrency)];
                    case 5:
                        _b.sent();
                        this.initialised = true;
                        return [2 /*return*/, this];
                }
            });
        });
    };
    InjectedConnector.prototype.updateFeeCurrency = function (feeContract) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.feeCurrency = feeContract;
                        return [4 /*yield*/, this.kit.setFeeCurrency(feeContract)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    InjectedConnector.prototype.updateKitWithNetwork = function (network) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        localStorage_1.default.setItem(constants_1.localStorageKeys.lastUsedNetwork, network.name);
                        return [4 /*yield*/, this.initialise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    InjectedConnector.prototype.onNetworkChange = function (callback) {
        this.onNetworkChangeCallback = callback;
    };
    InjectedConnector.prototype.onAddressChange = function (callback) {
        this.onAddressChangeCallback = callback;
    };
    InjectedConnector.prototype.close = function () {
        (0, helpers_1.clearPreviousConfig)();
        var ethereum = (0, ethereum_1.getEthereum)();
        if (ethereum) {
            ethereum.removeListener('chainChanged', this.onChainChanged);
            ethereum.removeListener('accountsChanged', this.onAccountsChanged);
        }
        this.onNetworkChangeCallback = undefined;
        this.onAddressChangeCallback = undefined;
        return;
    };
    return InjectedConnector;
}());
exports.InjectedConnector = InjectedConnector;
var MetaMaskConnector = /** @class */ (function (_super) {
    __extends(MetaMaskConnector, _super);
    function MetaMaskConnector(network, feeCurrency) {
        return _super.call(this, network, feeCurrency, constants_1.WalletTypes.MetaMask) || this;
    }
    return MetaMaskConnector;
}(InjectedConnector));
exports.MetaMaskConnector = MetaMaskConnector;
var CeloExtensionWalletConnector = /** @class */ (function () {
    function CeloExtensionWalletConnector(network, feeCurrency) {
        this.feeCurrency = feeCurrency;
        this.initialised = false;
        this.type = constants_1.WalletTypes.CeloExtensionWallet;
        this.account = null;
        localStorage_1.default.setItem(constants_1.localStorageKeys.lastUsedWalletType, constants_1.WalletTypes.CeloExtensionWallet);
        localStorage_1.default.setItem(constants_1.localStorageKeys.lastUsedWalletArguments, JSON.stringify([feeCurrency]));
        localStorage_1.default.setItem(constants_1.localStorageKeys.lastUsedNetwork, network.name);
        this.kit = (0, contractkit_1.newKit)(network.rpcUrl);
    }
    CeloExtensionWalletConnector.prototype.initialise = function () {
        return __awaiter(this, void 0, void 0, function () {
            var Web3, celo, web3, _a, defaultAccount;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('web3')); })];
                    case 1:
                        Web3 = (_b.sent()).default;
                        celo = window.celo;
                        if (!celo) {
                            throw new Error('Celo Extension Wallet not installed');
                        }
                        web3 = new Web3(celo);
                        return [4 /*yield*/, celo.enable()];
                    case 2:
                        _b.sent();
                        web3.currentProvider.publicConfigStore.on('update', function (_a) {
                            var networkVersion = _a.networkVersion;
                            if (_this.onNetworkChangeCallback) {
                                _this.onNetworkChangeCallback(networkVersion);
                            }
                        });
                        this.kit = (0, contractkit_1.newKitFromWeb3)(web3);
                        return [4 /*yield*/, this.kit.web3.eth.getAccounts()];
                    case 3:
                        _a = __read.apply(void 0, [_b.sent(), 1]), defaultAccount = _a[0];
                        this.kit.defaultAccount = defaultAccount;
                        this.account = defaultAccount !== null && defaultAccount !== void 0 ? defaultAccount : null;
                        return [4 /*yield*/, this.updateFeeCurrency(this.feeCurrency)];
                    case 4:
                        _b.sent();
                        this.initialised = true;
                        return [2 /*return*/, this];
                }
            });
        });
    };
    CeloExtensionWalletConnector.prototype.updateFeeCurrency = function (feeContract) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.feeCurrency = feeContract;
                        return [4 /*yield*/, this.kit.setFeeCurrency(this.feeCurrency)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CeloExtensionWalletConnector.prototype.onNetworkChange = function (callback) {
        this.onNetworkChangeCallback = callback;
    };
    CeloExtensionWalletConnector.prototype.close = function () {
        (0, helpers_1.clearPreviousConfig)();
        return;
    };
    return CeloExtensionWalletConnector;
}());
exports.CeloExtensionWalletConnector = CeloExtensionWalletConnector;
var WalletConnectConnector = /** @class */ (function () {
    function WalletConnectConnector(network, feeCurrency, 
    // options: WalletConnectWalletOptions | WalletConnectWalletOptionsV1,
    options, autoOpen, getDeeplinkUrl, version) {
        if (autoOpen === void 0) { autoOpen = false; }
        this.network = network;
        this.feeCurrency = feeCurrency;
        this.autoOpen = autoOpen;
        this.getDeeplinkUrl = getDeeplinkUrl;
        this.version = version;
        this.initialised = false;
        this.type = constants_1.WalletTypes.WalletConnect;
        this.account = null;
        localStorage_1.default.setItem(constants_1.localStorageKeys.lastUsedWalletType, constants_1.WalletTypes.WalletConnect);
        localStorage_1.default.setItem(constants_1.localStorageKeys.lastUsedWalletArguments, JSON.stringify([feeCurrency, options]));
        localStorage_1.default.setItem(constants_1.localStorageKeys.lastUsedNetwork, network.name);
        var wallet = new wallet_walletconnect_v1_1.WalletConnectWallet(options);
        // Uncomment with WCV2 support
        // version == 1
        //   ? new WalletConnectWalletV1(options as WalletConnectWalletOptionsV1)
        //   : new WalletConnectWallet(options as WalletConnectWalletOptions);
        this.kit = (0, contractkit_1.newKit)(network.rpcUrl, wallet);
        this.version = version;
    }
    WalletConnectConnector.prototype.onUri = function (callback) {
        this.onUriCallback = callback;
    };
    WalletConnectConnector.prototype.onClose = function (callback) {
        this.onCloseCallback = callback;
    };
    WalletConnectConnector.prototype.initialise = function () {
        return __awaiter(this, void 0, void 0, function () {
            var wallet, uri, deepLink, _a, address, defaultAccount;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        wallet = this.kit.getWallet();
                        if (this.onCloseCallback) {
                            // Uncomment with WCV2 support
                            // wallet.onPairingDeleted = () => this.onCloseCallback?.();
                            wallet.onSessionDeleted = function () { var _a; return (_a = _this.onCloseCallback) === null || _a === void 0 ? void 0 : _a.call(_this); };
                        }
                        return [4 /*yield*/, wallet.getUri()];
                    case 1:
                        uri = _b.sent();
                        if (uri && this.onUriCallback) {
                            this.onUriCallback(uri);
                        }
                        if (uri && this.autoOpen) {
                            deepLink = this.getDeeplinkUrl ? this.getDeeplinkUrl(uri) : uri;
                            location.href = deepLink;
                        }
                        return [4 /*yield*/, wallet.init()];
                    case 2:
                        _b.sent();
                        _a = __read(wallet.getAccounts(), 1), address = _a[0];
                        return [4 /*yield*/, this.fetchWalletAddressForAccount(address)];
                    case 3:
                        defaultAccount = _b.sent();
                        this.kit.defaultAccount = defaultAccount;
                        this.account = defaultAccount !== null && defaultAccount !== void 0 ? defaultAccount : null;
                        return [4 /*yield*/, this.updateFeeCurrency(this.feeCurrency)];
                    case 4:
                        _b.sent();
                        this.initialised = true;
                        return [2 /*return*/, this];
                }
            });
        });
    };
    WalletConnectConnector.prototype.fetchWalletAddressForAccount = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var accounts, walletAddress;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!address) {
                            return [2 /*return*/, undefined];
                        }
                        return [4 /*yield*/, this.kit.contracts.getAccounts()];
                    case 1:
                        accounts = _a.sent();
                        return [4 /*yield*/, accounts.getWalletAddress(address)];
                    case 2:
                        walletAddress = _a.sent();
                        return [2 /*return*/, new bignumber_js_1.BigNumber(walletAddress).isZero() ? address : walletAddress];
                }
            });
        });
    };
    WalletConnectConnector.prototype.updateFeeCurrency = function (feeContract) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.feeCurrency = feeContract;
                        return [4 /*yield*/, this.kit.setFeeCurrency(feeContract)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WalletConnectConnector.prototype.close = function () {
        (0, helpers_1.clearPreviousConfig)();
        var wallet = this.kit.getWallet();
        return wallet.close();
    };
    return WalletConnectConnector;
}());
exports.WalletConnectConnector = WalletConnectConnector;
//# sourceMappingURL=connectors.js.map